// extracted by mini-css-extract-plugin
export default {"termCode":"TermSelect_termCode__9B-bv","termDate":"TermSelect_termDate__PDGtE"};